import React from 'react';
import PropTypes from 'prop-types';

import './ResearchArea.css';

import ExtendedRealityIcon from '../../images/home/extended-reality-icon.png';
import ComputerVisionIcon from '../../images/home/computer-vision-icon.png';
import OtimizacaoDeProcessosIcon from '../../images/home/otimizacao-de-processos-icon.png';


function ResearchArea(props) {
  const { area } = props;
  let image; let alt; let description; let firstPartTitle; let secondPartTitle;

  switch (area) {
    case 'EXTENDED REALITY':
      image = ExtendedRealityIcon;
      alt = 'Extended reality glasses icon';
      description = 'Explorando as fronteiras da \ninteração entre o virtual e o real.';
      firstPartTitle = 'REALIDADE ';
      secondPartTitle = 'ESTENDIDA';
      break;

    case 'COMPUTER VISION':
      image = ComputerVisionIcon;
      alt = 'Computer vision eye icon';
      description = 'Máquinas interpretando espaços \natravés de imagens e sensores.';
      firstPartTitle = 'VISÃO ';
      secondPartTitle = 'COMPUTACIONAL';
      break;

    case 'NATURAL INTERACTION':
      image = OtimizacaoDeProcessosIcon;
      alt = 'Natural interaction open palm icon';
      description = 'Automação e digitalização \natravés de inteligência artificial.';
      firstPartTitle = 'DIGITALIZAÇÃO ';
      secondPartTitle = 'DE PROCESSOS';
      break;

    default:
      break;
  }


  return (
    <div className="ResearchArea">
      <div className="imageDiv">
        <img src={image} alt={alt} />
      </div>
      <div className="textDiv">
        <h4>
          {firstPartTitle}
          <span>{secondPartTitle}</span>
        </h4>
        <p>{description}</p>
      </div>
    </div>
  );
}

ResearchArea.propTypes = {
  area: PropTypes.string.isRequired,
};


export default ResearchArea;
